export enum SigningState {
  NotStarted = 'not-started',
  InProcess = 'in-process',
  Finished = 'finished',
  Refused = 'refused',
  Cancelled = 'canceled',
  Error = 'error',
  Timeout = 'timeout',
  Blocked = 'blocked',
  NA = 'na',
}
